import React from "react";
import "../../components/section/section.css";
import "../../components/sectionRow/sectionRow.css";
import llamado from "../../img/llamado-1-mb@2x.png";
import scooter from "../../img/scooter-title-mb@2x.png";

import SectionRow from "../sectionRow/SectionRow";

const Section = () => {
  return (
    <div className="transporte">
      <div className="containerSection">
        <div className="btnMostaza">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="67.856"
            height="56.547"
            viewBox="0 0 67.856 56.547"
          >
            <path
              id="_001-scooter"
              data-name="001-scooter"
              d="M58.038,36.759,47.953,2.038A2.827,2.827,0,0,0,45.237,0H36.755a2.827,2.827,0,1,0,0,5.655h6.359L49.306,26.97,38.07,43.824H19.791V38.169A11.322,11.322,0,0,0,8.482,26.86H2.827a2.827,2.827,0,1,0,0,5.655H8.482A5.643,5.643,0,0,1,14.09,37.7a9.889,9.889,0,1,0,5.285,11.777H39.583a2.825,2.825,0,0,0,2.352-1.26l9.433-14.149,1.241,4.271a9.884,9.884,0,1,0,5.429-1.581ZM9.9,50.892a4.241,4.241,0,1,1,4.241-4.241A4.247,4.247,0,0,1,9.9,50.892Zm48.065,0A4.241,4.241,0,1,1,62.2,46.651,4.247,4.247,0,0,1,57.96,50.892Zm0,0"
              fill="#682666"
            />
          </svg>
          <p>SCOOTERS</p>
        </div>
        <div className="btnYellow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89.383"
            height="57.439"
            viewBox="0 0 89.383 57.439"
          >
            <path
              id="_002-bycicle"
              data-name="002-bycicle"
              d="M68.9,114.908,62.609,97.174h9.556a1.113,1.113,0,0,1,1.112,1.112v1.72a1.113,1.113,0,0,1-1.112,1.112,2.79,2.79,0,1,0,0,5.58,6.7,6.7,0,0,0,6.692-6.692v-1.72a6.7,6.7,0,0,0-6.692-6.692H58.658a2.791,2.791,0,0,0-2.629,3.723l2.61,7.354H36.813l-1.951-5.5h2.8a2.79,2.79,0,1,0,0-5.58H30.911a2.791,2.791,0,0,0-2.629,3.723l3.529,9.945-7.246,10.982a17.217,17.217,0,1,0,9.529,18.992H44.418a2.79,2.79,0,0,0,2.329-1.253L61.7,111.312l1.963,5.531a17.208,17.208,0,1,0,5.234-1.936Zm-34.752-3.057,6.318,17.806H34.3a17.186,17.186,0,0,0-5.146-10.238ZM26,124.2a11.6,11.6,0,0,1,2.648,5.461H22.4Zm-8.786,19.257a11.637,11.637,0,1,1,4.227-22.479l-6.555,9.936a2.792,2.792,0,0,0,2.329,4.327H28.343A11.659,11.659,0,0,1,17.219,143.453Zm27.956-17.218-6.382-17.984H57.039Zm26.99,17.218a11.634,11.634,0,0,1-6.587-21.226l3.958,11.153a2.79,2.79,0,1,0,5.259-1.866L70.8,120.259a11.637,11.637,0,1,1,1.364,23.194Z"
              transform="translate(0 -91.594)"
              fill="#682666"
            />
          </svg>
          <p>BICICLETAS</p>
        </div>
        <div className="btnMostaza">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89.151"
            height="62.295"
            viewBox="0 0 89.151 62.295"
          >
            <path
              id="_003-transportation"
              data-name="003-transportation"
              d="M72.552,106.214c-.384,0-.764.014-1.141.04l-1.386-6.006H72.34a8.207,8.207,0,1,0,0-16.414h-6.32c-1.705-3.9-5.342-6.714-9.006-6.714h-5.6a2.612,2.612,0,1,0,0,5.224h5.6c1.661,0,3.99,2.049,4.623,4.79l1.175,5.093H47.956c-4.827,0-10.154,3.092-12.128,7.039l-1.2,2.4a27.829,27.829,0,0,0-4.7-3.233v-5.2a9.516,9.516,0,0,0-9.606-9.4H11.931a9.617,9.617,0,0,0-9.606,9.606V98.97c-.393.236-.783.478-1.166.734a2.612,2.612,0,1,0,2.906,4.341,22.537,22.537,0,0,1,2.1-1.245l.035-.019a22.578,22.578,0,0,1,26.994,4.741l5.432,10.864a2.612,2.612,0,0,0,2.336,1.444H52.818L47.385,125.8H32.931a16.621,16.621,0,1,0-1.906,5.224H48.539a2.612,2.612,0,0,0,1.931-.853L56,124.093a16.6,16.6,0,1,0,16.551-17.879Zm-65-9.683V93.439a4.387,4.387,0,0,1,4.382-4.383h8.392a4.289,4.289,0,0,1,4.382,4.178v3a27.808,27.808,0,0,0-17.157.294ZM16.6,134.19a11.39,11.39,0,1,1,11.191-9.343L17.645,120.42a2.612,2.612,0,1,0-2.089,4.788L25.7,129.634A11.366,11.366,0,0,1,16.6,134.19ZM75.324,92.04a2.987,2.987,0,0,1-2.984,2.984H68.819l-1.377-5.967h4.9A2.987,2.987,0,0,1,75.324,92.04ZM47.956,97.45H64.018l1.377,5.967h-25.8L40.5,101.6C41.606,99.39,45.09,97.45,47.956,97.45Zm-5.38,17.157-2.983-5.967H63.92a16.726,16.726,0,0,0-3.471,2.826c-.051.048-.1.1-.15.149l-2.724,2.992h-15ZM72.552,134.19a11.374,11.374,0,0,1-5.034-21.574L70.007,123.4a2.612,2.612,0,0,0,5.09-1.175l-2.489-10.787a11.376,11.376,0,0,1-.056,22.751Z"
              transform="translate(0 -77.119)"
              fill="#682666"
            />
          </svg>
          <p className="margenException">MOTO</p>
        </div>
        <div className="btnYellow">
          <svg
            id="Grupo_35"
            data-name="Grupo 35"
            xmlns="http://www.w3.org/2000/svg"
            width="63.412"
            height="63.525"
            viewBox="0 0 63.412 63.525"
          >
            <path
              id="Trazado_65"
              data-name="Trazado 65"
              d="M1388.807,549.468a7.721,7.721,0,0,0,9.132-2.737l4.945-7.015a8.25,8.25,0,0,0,.645-8.495,38.01,38.01,0,0,0-13.461-15.414,31.475,31.475,0,0,0-16.8-4.816h0c-13.114,0-26.081,7.84-31.532,19.067a7.312,7.312,0,0,0-.286,5.677,7.388,7.388,0,0,0,3.927,4.192l14.99,6.64a11.418,11.418,0,0,0,3.239.895l4.759,11.731a2.354,2.354,0,0,1,.063,1.591l-3.219,10.223a1.8,1.8,0,0,0,1.073,2.217l3.11,1.184a1.671,1.671,0,0,0,2.164-.986l4.2-11.456a3.866,3.866,0,0,1,.888-1.394l11.356-11.422Zm-41.752-16.823c4.335-8.927,15.1-15.733,26.208-15.731,9.277,0,18.792,4.751,24.982,16.982a2.35,2.35,0,0,1-.2,2.408l-4.945,7.015a1.8,1.8,0,0,1-2.125.637l-.837-.329-7.749-3.044a3.056,3.056,0,0,0-1.118-.212c-.08,0-.161,0-.241.01l-11.145.881-1.764.14-2.668.211c-.146.012-.292.018-.438.018a5.579,5.579,0,0,1-2.257-.477l-14.989-6.64A1.388,1.388,0,0,1,1347.054,532.645Zm26.81,22.786-3.388-8.276,10.36-.819,1.253.493Z"
              transform="translate(-1341 -510.991)"
              fill="#682666"
            />
          </svg>
          <p className="margenException">ACCESORIOS</p>
        </div>
      </div>
      <br />
      <SectionRow />
      <div className="transporteEficiente">
        <img src={llamado} alt="" />
      </div>
      <div className="textTrans">
        <p>
          <strong>
            El scooter eléctrico contribuye a reducir la congestion vehicular y
            la contaminación urbana. Súbete a la electromovilidad hoy con
            nuestras mejores ofertas.
          </strong>
        </p>
      </div>
      <br />
      <div className="transporteScooter">
        <img src={scooter} alt="" />
      </div>
    </div>
  );
  
};

export default Section;
